import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as spaceLite from '../space-lite'

export const RESOURCE = {
  payload: {
    alias: 'space-lite:records-list',
    appAlias: spaceLite.RESOURCE.payload.alias,
    description: 'Records List page',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Records List',
    page: { id: prebuilt.Page.Id.SpaceLiteRecordsList },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
